import React, { useState } from 'react';
import { Box } from '@mui/system';
import { Tab, Tabs } from '@mui/material';
import Header from '../global/Header';
import ApiCountSummaries from './components/ApiCountSummaries';
import ChargesFeed from './components/ChargesFeed';

const MediaAPIs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box m="20px">
      <Header title="APIs" subtitle="Product-wide usage + credit monitoring" />

      <Tabs
        value={tabIndex}
        onChange={(event, newValue) => setTabIndex(newValue)}
        sx={{ backgroundColor: '#3F4957' }}
      >
        <Tab label="Credit Usage" style={{ color: tabIndex === 0 ? '#8FBC8F' : 'white' }} />
        <Tab label="Charges" style={{ color: tabIndex === 1 ? '#8FBC8F' : 'white' }} />
      </Tabs>

      {tabIndex === 0 && <ApiCountSummaries />}
      {tabIndex === 1 && <ChargesFeed />}
    </Box>
  );
};

export default MediaAPIs;
